var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "face-24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TOPBARST-/-NoLicense",
    transform: "translate(-1188.000000, -32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "face-24px",
    transform: "translate(1188.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 32 0 32 32 0 32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,15.6666667 C11.08,15.6666667 10.3333333,16.4133333 10.3333333,17.3333333 C10.3333333,18.2533333 11.08,19 12,19 C12.92,19 13.6666667,18.2533333 13.6666667,17.3333333 C13.6666667,16.4133333 12.92,15.6666667 12,15.6666667 Z M20,15.6666667 C19.08,15.6666667 18.3333333,16.4133333 18.3333333,17.3333333 C18.3333333,18.2533333 19.08,19 20,19 C20.92,19 21.6666667,18.2533333 21.6666667,17.3333333 C21.6666667,16.4133333 20.92,15.6666667 20,15.6666667 Z M16,2.66666667 C8.64,2.66666667 2.66666667,8.64 2.66666667,16 C2.66666667,23.36 8.64,29.3333333 16,29.3333333 C23.36,29.3333333 29.3333333,23.36 29.3333333,16 C29.3333333,8.64 23.36,2.66666667 16,2.66666667 Z M16,26.6666667 C10.12,26.6666667 5.33333333,21.88 5.33333333,16 C5.33333333,15.6133333 5.36,15.2266667 5.4,14.8533333 C8.54666667,13.4533333 11.04,10.88 12.3466667,7.69333333 C14.76,11.1066667 18.7333333,13.3333333 23.2266667,13.3333333 C24.2666667,13.3333333 25.2666667,13.2133333 26.2266667,12.9866667 C26.5066667,13.9333333 26.6666667,14.9466667 26.6666667,16 C26.6666667,21.88 21.88,26.6666667 16,26.6666667 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceIcon);
export default __webpack_public_path__ + "static/media/face-icon.801c6d59.svg";
export { ForwardRef as ReactComponent };